import { isJSON } from "@/api/utils";
import { sliceEncrypt, filePreview, linkedSetEvent, getOrgShowName } from "@/api/global.js";
import { tableStatus } from '@/api/utils'  
import { getlinkeddatalist, getsearchbuttoninfo } from '@/port/clientSide/oaExamineAudit'
import tableRead from '../../formFillinPageChild/detailsTable/tableRead.vue'
import radioXing from '@/components/clientSide/formFillinPageChild/widgetCommon/radioXing.vue'
export default {
  data() {
    return {
      isLinkObj: {},
    }
  },
  props: {
    fileProperty: {
      type: Object,
      default: ()=>({})
    }
  },
  components: {
    tableRead,
    radioXing,
    // relationUserInfo: () => import('@/components/clientSide/common/relationUserInfo'),
  },
  watch: {
    listData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val && val.data && val.data.length > 0 && val.data[0].content && val.data[0].content.length > 0) {
          const obj = {}
            for (const i of val.data[0].content) {
              if (i && i.type === 'text' && i.isLink && i.isLink === 'true') {
                obj[i.title] = true
              }
            }
            this.isLinkObj = obj
        } else {
          this.isLinkObj = {}
        }
      }
    },
  },
  methods: {
    isJSON(val) {
      return isJSON(val)
    },
    isArrAndNoLen(val) {
      return Array.isArray(val) && val.length !== 0
    },
    goPreview (val, down) {
      filePreview(val, down)
    },
    strImgAndFileData(val) {
      if (!val) return ''
      let filename = ''
      if (typeof val === 'object') {
        filename = val.realname || val.response || ''
      } else {
        filename = val
      }
      if (!filename) return ''
      try {
        const mps = filename.split('/')
        const mp = mps[mps.length - 1]
        const str = mp.split('-')[1]
        return str || filename
      } catch (err) {
        return filename
      }
    },
    // 获取文件类型
    getFileFormat (name) {
      if (name) {
        let site = name.lastIndexOf("\\.");
        let format =  name.substring(site + 1, name.length);
        format = format.toLocaleLowerCase()
        const formatList = ['mp3', 'mp4', 'aac', 'mp4', 'wmv', 'avi', 'flv']
        return formatList.includes(format)
      } else {
        return false
      }
    },
    getRelCheck (item) {
      try {
        if (typeof item === 'object') {
          return item.top && item.data && item.data.length > 0 ? item : false
        } else {
          return JSON.parse(item)
        }
      } catch (e) {
        console.log(e)
        return false
      }
    },
    strData (e, n) {
      if (e instanceof Array) { //如果为数组
        if (e[0] && e[0].userId) { //如果有userId说明是联系人控件
          let ej = [];
          e.forEach(i => {
            ej.push(i.realname)
          });
          return ej.join(',')
        } else if (e[0] && (e[0].organizationId || e[0].roleId)) {
          //如果有organizationId或roleId说明是组织控件或角色控件
          let ej = [];
          e.forEach((i) => {
            let name = i.name
            if (i.organizationId) {
              name = getOrgShowName(i)
            }
            ej.push(name);
          });
          return ej.join(",");
        } else {
          return e.join(',')
        }
      } else {
        return sliceEncrypt(e, n)
      }
    },
    // 保留两位小数
    toDecimal(num) {
      return num.split('.').length > 1 ? Number(num).toFixed(2) : num
    },
    // 查询控件查询
    async queryData(rowData, val){
      let that = this
      let ele = val
      that.approvingId = rowData.approvingId
      const param = { 
          approvalId: that.$route.query.approvalId || that.appid,
          approvingId: that.approvingId,
          feild: val.title + '_' + val.type
        }
      getsearchbuttoninfo(param).then(async (res) => {
        if (res.code === 0) {
          let param = linkedSetEvent(res.data.dataconfig, JSON.parse(res.data.data), {
            types: false
          });
          ele.dataconfig = res.data.dataconfig
          if (param) {
            let x = await that.awaitGetlinkeddatalist(param)
            that.linkeddataResult(ele, x)
          }
        }
      });
    },
    awaitGetlinkeddatalist(pargam) {
      const that = this
      return new Promise(function(resolve) {
				// console.log('添加approvalId和approvingId',this.approvalId,this.approvingId)
				pargam.approvalId = that.$route.query.approvalId || that.approvalId
				pargam.approvingId = that.approvingId
        getlinkeddatalist(pargam).then(res => {
          resolve(res.data);
        });
      });
    },
    linkeddataResult(item, res) {
      console.log('返回联动', item, res)
      let that = this
      let resultVal
      const listData = that.listData.data
        //- 控件后台给的数据错误少了一个层级
        if (res !== null) {
          // 填充查询
          if (item.dataconfig && item.dataconfig.setUpValue === 1) {
            resultVal = res[0]
          }
          // 点击查询
          else{
            resultVal = res;
          }
          for(let i = 0; i < listData.length; i++){
            if(listData[i].approvingId === that.approvingId){
              listData[i][item.title] = resultVal
              console.log("listData",listData)
              break;
            }
          }
          that.listData.data = listData
      }
    },
    // 返回定位控件值
    getLocationVal(data){
      if(data == '') return ''
      const val = typeof data === 'string' ? JSON.parse(data) : data
      if(val.length > 0){
        return val[0]['addressName']
      }
      else{
        return ''
      }
    },
    statusFun (val) {
      return tableStatus(val)
    },
    getRadioLabel (val, item) {
      if (!item || item.length === 0) return val
      for (const i of item) {
        if (i.value === val) return i.label
      }
      return val
    },
    openLinkText (val) {
      window.open(val)
    },
    getTimeLabels (val, scope) {
      if (!val || !scope) return ''
      if (val.type === 'date' && scope.row[val.title] && val.timeList && val.timeList.open && val.timeList.options && val.timeList.options.length > 0) {
          const label = this.getTimeLabel(scope.row[val.title], val.timeList.options)
          return label
      }
      let value = this.strData(scope.row[val.title], val.encrypt)
      if (value && value.includes('1970-01-01')) {
        try {
          value = value.split(' ')[1].split(':').slice(0, 2).join(':')
        } catch (err) { console.log(err) }
      }
      return value
    },
  }
}